import { hasElements, OptionalVariableData } from '../../core/utils';
import { getBoundsFromPosition } from '../../core/components/Map';
import { FilterConditions, Geofence, Point, VariablesResponse, VariableValue } from '../../core/models';

export * from './types';
export * from './tours';

export const cssNormal = 'has__dialog__head';
export const cssWarning = 'has__dialog__head__warning';
export const cssError = 'has__dialog__head__error';

export const geofenceReprocessMsg = 'El cambio se vera impactado en los reportes 7 dias para atras';
export const geofenceSuccessPatchMsg = 'Geocerca editada correctamente'
export const geofencePatchError = 'No se pudo modificar la geocerca';
export const getGeofenceError = 'No se pudieron traer las geocercas';

export enum VariablesOptions {
    VEHICLE_STATE = 'Estado del vehículo'
}

export interface LastReportFilters {
    vehicleTypes: number[];
    vehicleStates: number[];
    filterWithRecentActivity: boolean;
    filtersWithLoad: boolean;
}

export enum VariablesTypes {
    HUMIDITY = 'variable_report_humidity',
    TOTAL_DISTANCE = 'variable_report_total_distance',
    PERFORMANCE = 'variable_report_performance',
    TOTAL_HOURS_OPERATIONAL = 'variable_report_total_hours_operational',
    GPS_STATUS = 'Estado de GPS',
    GPS_STATUS_ID = 'gps_status',
    GPS_DIRECTION = 'Dirección GPS',
    GPS_SIGNAL_ID = 'gps_signal',
    GPS_SIGNAL = 'Señal de GPS',
    GPS_MODE = 'gps_mode',
    GPS_LATITUDE = 'gps_latitude',
    GPS_LONGITUDE = 'gps_longitude',
    GPS_ALTITUDE = 'gps_altitude',
    GPRS_REGISTRATION_STATUS = 'gprs_registration_status',
    GPS_SIGNAL_QUALITY = 'gps_signal_quality',
    GPRS_SIGNAL_QUALITY = 'gprs_signal_quality',
    GSM_REGISTRATION_STATUS = 'gsm_registration_status',
    GPS_SATELITES_NUMBER = 'gps_satelites_number',
    GPS_DIRECTION_ID = 'gps_direction',
    LATITUDE = 'Latitud',
    LONGITUDE = 'Longitud',
    ALTITUDE = 'GPS Error',
    VEHICLE_ID = 'vehicle_id',
    VEHICLE_STATE = 'vehicle_state',
    TIN = 'tin',
    FRAME_ID = 'frame_id',
    POSITION = 'position',
    AVG_POSITION = 'Posición aproximada',
    ID = 'id',
    VOLTAGE_BATTERY = 'voltage_battery',
    MESSAGE_TYPE = 'message_type',
    SPEED = 'speed',
    SPEED_ES = 'Velocidad',
    GPS_SPEED = 'gps_speed',
    GPS_SPEED_ES = 'Velocidad GPS'
}

export const speedVariables = [
    VariablesTypes.SPEED,
    VariablesTypes.SPEED_ES,
    VariablesTypes.GPS_SPEED,
    VariablesTypes.GPS_SPEED_ES,
]

export const variablesSmartway = [
    VariablesTypes.GPS_STATUS,
    VariablesTypes.GPS_SIGNAL,
    VariablesTypes.GPS_MODE,
    VariablesTypes.GPS_DIRECTION,
    VariablesTypes.GPRS_REGISTRATION_STATUS,
    VariablesTypes.GPRS_SIGNAL_QUALITY,
    VariablesTypes.GSM_REGISTRATION_STATUS,
    VariablesTypes.GPS_SATELITES_NUMBER,
    VariablesTypes.LATITUDE,
    VariablesTypes.VEHICLE_ID,
    VariablesTypes.ALTITUDE,
    VariablesTypes.TIN,
    VariablesTypes.FRAME_ID,
    VariablesTypes.ID,
    VariablesTypes.VOLTAGE_BATTERY,
    VariablesTypes.MESSAGE_TYPE,
    VariablesTypes.VEHICLE_STATE
];

export const getVariableDescription = (variable: string): string => {
    if (variable === VariablesTypes.POSITION) {
        return VariablesTypes.AVG_POSITION;
    } else if (variable === VariablesTypes.GPS_LATITUDE) {
        return VariablesTypes.LATITUDE;
    } else if (variable === VariablesTypes.GPS_LONGITUDE) {
        return VariablesTypes.LONGITUDE;
    } else if (variable === VariablesTypes.GPS_ALTITUDE) {
        return VariablesTypes.ALTITUDE;
    } else if (variable === VariablesTypes.GPS_DIRECTION_ID) {
        return VariablesTypes.GPS_DIRECTION;
    } else if (variable === VariablesTypes.GPS_STATUS_ID) {
        return VariablesTypes.GPS_STATUS;
    } else if (variable === VariablesTypes.GPS_SIGNAL_QUALITY) {
        return VariablesTypes.GPS_SIGNAL;
    }
    return variable;
}

export const getUnitByVarDescription = (variableDescription: string, availableVariables:OptionalVariableData ) => {
    if (availableVariables && hasElements(Object.keys(availableVariables))) {
        let obj = Object.values(availableVariables);
        let itemDesc = obj.find(o => o.description === variableDescription);
        if (itemDesc !== undefined) {
            return itemDesc.unit;
        }
        return '';
    }
}



export enum FilterType {
    GREATER_THAN = 'Mayor a',
    LESS_THAN = 'Menor a',
    EQUAL_TO = 'Igual a',
    RANGE = 'Rango'
}

export enum PaintingType {
    RED_GREEN = 'Rojo -> Verde',
    GREEN_RED = 'Verde -> Rojo'
}

export const getNumberByFilterType = (type: FilterType): number => {
    switch (type) {
        case FilterType.GREATER_THAN:
            return 0;
        case FilterType.LESS_THAN:
            return 1;
        case FilterType.EQUAL_TO:
            return 2;
        default:
            return 3;
    }
};

export const getFilterTypeByNumber = (type: number): FilterType => {
    switch (type) {
        case 0:
            return FilterType.GREATER_THAN;
        case 1:
            return FilterType.LESS_THAN;
        case 2:
            return FilterType.EQUAL_TO;
        default:
            return FilterType.RANGE;
    }
};

export const getNumberByPaintingType = (type: PaintingType): number => {
    switch (type) {
        case PaintingType.RED_GREEN:
            return 0;
        default:
            return 1;
    }
};

export const getPaintingTypeByNumber = (type: number): PaintingType => {
    switch (type) {
        case 0:
            return PaintingType.RED_GREEN;
        default:
            return PaintingType.GREEN_RED;
    }
};

export const buildCondition = (
    variable: VariableValue | null,
    filterType: FilterType,
    min: string,
    max: string,
    exact: string,
    name: string
): FilterConditions | null => {
    if (variable && filterType === FilterType.RANGE) {
        return {
            variable: variable,
            typeFilter: getNumberByFilterType(filterType),
            values: [+min, +max],
            name
        };
    } else if (variable && filterType === FilterType.EQUAL_TO) {
        return {
            variable: variable,
            typeFilter: getNumberByFilterType(filterType),
            values: [+exact],
            name
        };
    } else if (variable && filterType === FilterType.GREATER_THAN) {
        return {
            variable: variable,
            typeFilter: getNumberByFilterType(filterType),
            values: [+min],
            name
        };
    } else if (variable && filterType === FilterType.LESS_THAN) {
        return {
            variable: variable,
            typeFilter: getNumberByFilterType(filterType),
            values: [+max],
            name
        };
    } else {
        return null;
    }
};

export const buildDescription = (
    variable: VariableValue | null,
    filterType: FilterType,
    min: string,
    max: string,
    exact: string
): string => {
    if (variable && filterType === FilterType.RANGE) {
        return `${variable.description} ${filterType} ${min} a ${max} ${variable.unit}`;
    } else if (variable && filterType === FilterType.EQUAL_TO) {
        return `${variable.description} ${filterType} ${exact} ${variable.unit}`;
    } else if (variable && filterType === FilterType.GREATER_THAN) {
        return `${variable.description} ${filterType} ${min} ${variable.unit}`;
    } else if (variable && filterType === FilterType.LESS_THAN) {
        return `${variable.description} ${filterType} ${max} ${variable.unit}`;
    } else {
        return '';
    }
};

export const getPointOfInterestAlertForDeletion = (
    pointOfInterest: Point[]
) => {
    /* Mensajes de confirmacion para eliminacion de puntos de interes */
    let quantity = pointOfInterest.length;
    let pointsOfInterestDescription = pointOfInterest.map(p => p['description']).join(', ');
    if(quantity > 1){
        return `¿Desea eliminar los ${quantity} puntos de interés: <b>${pointsOfInterestDescription}</b>?`;
    }
    return `¿Desea eliminar el punto de interés <b>${pointOfInterest[0]['description']}</b>?`;
}

export const getSingleGeofenceAlertForDeletion = (
    geofenceInfo: Geofence
) => {
    /* Mensaje de confirmacion para eliminar una unica geocerca */
    let alert = '';
    if (geofenceInfo.alarms > 0) {
        alert += `<p class='mb-0'>Esta geocerca esta asociada a <b>${geofenceInfo.alarms}</b> <b>Alarma</b>.</p>`;
        alert += `<p>La geocerca sera desvinculada de la/s Alarmas<br> <b>Nota:</b> Si la alarma no queda con ninguna geocerca asignada, esta sera eliminada</p>`
    }

    if(geofenceInfo.reports > 0){
        alert += `<p class='mb-0'>Esta geocerca esta asociada a <b>${geofenceInfo.reports}</b> <b>Reportes</b>.</p>`;
        alert += `<p>Eliminar esta geocerca puede generar cambios en estos reportes.</p>`;
    }

    alert += `<p><b>¿Desea eliminar la geocerca: ${geofenceInfo['description']}?</b></p>`;

    return alert;

}

export const getGeofenceAlertForDeletion = (
    geofencesList: Geofence[]
) => {
    /* Alerta cuando se elimina una lista de geocercas */
    let hasReportsAssigned = geofencesList.some(g => g.reports > 0);
    let hasAlarmsAssigned = geofencesList.some(g => g.alarms > 0);

    let alert = '';
    if (hasAlarmsAssigned) {
        alert += `<p class='mb-0'>Al menos una de las geocercas seleccionadas esta asociada a una <b>Alarma</b>.</p>`;
        alert += `<p>Las geocercas asociadas a la Alarma seran desvinculadas de ella.<br> <b>Nota:</b> Si la alarma no queda con ninguna geocerca asignada, esta sera eliminada</p>`
    }
    
    if (hasReportsAssigned) {
        alert += `<p class='mb-0'>Al menos una de las geocercas seleccionadas esta asociada a un <b>Reporte</b>.</p>`;
        alert += `<p>Eliminar estas geocercas puede generar cambios en estos reportes.</p>`;
    }

    if(!hasReportsAssigned && !hasAlarmsAssigned){
        let geofencesDescriptions = geofencesList.map(g => g['description']).join(', ');
        alert += `<p><b>¿Desea eliminar las geocercas: ${geofencesDescriptions}?</b></p>`;
    }else{
        alert += `<p><b>¿Desea continuar?</b></p>`;
    }

    return alert;
}

export const getGeofenceAlertForEdition = (
    reportsAsigned: number,
    alarmsAsigned: number
) => {
    let hasReportsAssigned = reportsAsigned > 0;
    let hasAlarmsAssigned = alarmsAsigned > 0;

    let alert = '';
    if (hasAlarmsAssigned) {
        alert += `<p>Esta geocerca esta asociada a <b>${alarmsAsigned}</b> Alarmas.</p><br>`;
    }
    
    if (hasReportsAssigned) {
        alert += `<p>Esta geocerca esta asociada a <b>${reportsAsigned}</b> Reportes.</p>`;
        alert += `<p>Modificar esta geocerca puede generar cambios en estos reportes.</p>`;
    }
    alert += `<p><b>¿Desea modificarla?</b></p>`;
    return alert;
}

export const buildVisualizationDescription = (variable: VariableValue | null, paintingType: PaintingType): string => {
    if (variable) {
        return `${variable.description} - ${paintingType}`;
    } else {
        return '';
    }
};

export const centerVehicleInMap = (positions: Point[], map: google.maps.Map, isOpenStatsPanel: boolean, mapClientHeight: number) => {
    let bounds = getBoundsFromPosition(positions,  isOpenStatsPanel, mapClientHeight);
    map.setCenter(bounds.getCenter());
    map.fitBounds(bounds);
    map.setZoom(12);
    setTimeout(() => {
        map.panBy(0, 200);
    }, 0);
}
